
import React, { memo } from 'react';
import Img from 'react-image';
import ImagesWithDescription from "../ImagesWithDescription"
import styles from '../../customDialogUploadFile.module.scss';
import { uploadImageSVG, warningSVG, syncFileSvg } from '../../../../helpers/icons';

const PreviewImage = ({
    previewImageBeforeUpload,
    fileInformation,
    validateWidthAndHeigth,
    notAvailable,
    maxWidth,
    maxHeigth,
    typesFile
}) =>
    <>
        {
            !previewImageBeforeUpload &&
            <>
                {
                    !notAvailable &&
                    <ImagesWithDescription
                        image={uploadImageSVG}
                        description={"home:drag_file_or_click_here"}
                        maxWidth={maxWidth}
                        maxHeigth={maxHeigth}
                        typesFile={typesFile}
                    />
                }
                {
                    notAvailable &&
                    <ImagesWithDescription
                        image={warningSVG}
                        description={"home:choosen_image_incorrect"}
                        maxWidth={maxWidth}
                        maxHeigth={maxHeigth}
                        typesFile={typesFile}
                    />
                }
            </>

        }
        {
            previewImageBeforeUpload &&
            <>
                {
                    (fileInformation && !fileInformation.name.includes(".xlsx")) ?
                        <div className={styles.content}>
                            <Img src={previewImageBeforeUpload} onLoad={validateWidthAndHeigth} />
                        </div>
                        : <ImagesWithDescription
                            image={syncFileSvg}
                            description={"home:preprocess_the_file"}
                            maxWidth={maxWidth}
                            maxHeigth={maxHeigth}
                            typesFile={typesFile}
                        />
                }
            </>
        }
    </>

export default memo(PreviewImage);